<template>

  <login-app />

</template>

<script>
import LoginApp from './components/Login-App.vue'




export default {
  name: 'App',
  components: {
    LoginApp,
  },
  data() {
    return {
      componentKey: 0,

    }
  },

  methods: {
    forceUpdate() {
      this.componentKey += 1;
    },
    
  },

}

</script>

<style>
.content-wrapper {
  /* background: #dddce19c; */
  background: #F4F6FA;

}

.sidebar {
  background: #F4F6FA;
}

.footer {
  background: #F4F6FA;
}
</style>
